// // BulkReferralUpdater.jsx

// import React, { useState, useEffect } from "react";
// import {
//     collection,
//     getDocs,
//     query,
//     where,
//     doc,
//     writeBatch,
//     updateDoc
// } from "firebase/firestore";
// import db from "./Firebase";
// import Swal from "sweetalert2";

// const BulkReferralUpdater = () => {
//     const [users, setUsers] = useState([]); // from funder_users_list
//     const [loaded, setLoaded] = useState(false);
//     const [running, setRunning] = useState(false);
//     const [result, setResult] = useState({ updated: 0, failed: 0 });

//     // Step 1: load funder_users_list
//     useEffect(() => {
//         const fetchUsers = async () => {
//             try {
//                 const colRef = collection(db, "funder_users_list");
//                 const snap = await getDocs(colRef);
//                 const arr = snap.docs.map(d => {
//                     const data = d.data();
//                     return {
//                         id: d.id,
//                         phone: String(data.phone_no || data.phone || "").trim(),
//                         age_range: data.age_range || ""
//                     };
//                 }).filter(u => u.phone);
//                 setUsers(arr);
//             } catch (err) {
//                 console.error("Error fetching funder_users_list:", err);
//                 Swal.fire("Error", "Could not load users", "error");
//             } finally {
//                 setLoaded(true);
//             }
//         };

//         fetchUsers();
//     }, []);

//     const handleSync = async () => {
//         if (!loaded) {
//             Swal.fire("Info", "Still loading data...", "info");
//             return;
//         }
//         if (users.length === 0) {
//             Swal.fire("Info", "No users to sync", "info");
//             return;
//         }

//         setRunning(true);
//         let updated = 0;
//         let failed = 0;

//         const BATCH_LIMIT = 400;

//         for (let i = 0; i < users.length; i += BATCH_LIMIT) {
//             const chunk = users.slice(i, i + BATCH_LIMIT);
//             const batch = writeBatch(db);

//             for (let u of chunk) {
//                 try {
//                     const { phone, age_range } = u;
//                     if (!phone) {
//                         failed++;
//                         continue;
//                     }

//                     const q = query(
//                         collection(db, "profile_type"),
//                         where("phone_no", "==", phone)
//                     );
//                     const snap = await getDocs(q);
//                     if (snap.empty) {
//                         console.warn("Profile not found for", phone);
//                         failed++;
//                     } else {
//                         snap.docs.forEach(docSnap => {
//                             const ref = doc(db, "profile_type", docSnap.id);
//                             // Only update age_range field
//                             batch.update(ref, { age_range: age_range });
//                         });
//                         updated++;
//                     }
//                 } catch (err) {
//                     console.error("Error syncing for user", u.phone, err);
//                     failed++;
//                 }
//             }

//             try {
//                 await batch.commit();
//             } catch (err) {
//                 console.error("Batch commit failed:", err);
//                 // count chunk as failure
//                 failed += chunk.length;
//             }
//         }

//         setRunning(false);
//         setResult({ updated, failed });
//         Swal.fire("Done", `Updated: ${updated}, Failed: ${failed}`, "success");
//     };

//     return (
//         <div className="container p-4">
//             <h3>Synchronize Age Range to profile_type</h3>
//             {!loaded ? (
//                 <p>Loading users...</p>
//             ) : (
//                 <>
//                     <p>Total users to sync: {users.length}</p>
//                     <button
//                         className="btn btn-primary"
//                         onClick={handleSync}
//                         disabled={running}
//                     >
//                         {running ? "Syncing..." : "Start Sync"}
//                     </button>
//                     {(result.updated || result.failed) && (
//                         <div className="mt-3">
//                             <p>✅ Updated: {result.updated}</p>
//                             <p>❌ Failed: {result.failed}</p>
//                         </div>
//                     )}
//                 </>
//             )}
//         </div>
//     );
// };

// export default BulkReferralUpdater;


import React, { useState, useEffect } from "react";
import {
    collection,
    query,
    getDocs,
    where,
    doc,
    writeBatch
} from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";

const BulkReferralUpdater = () => {
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [running, setRunning] = useState(false);
    const [result, setResult] = useState({ success: 0, failed: 0 });
    const [loaded, setLoaded] = useState(false);

    // 1. On mount, fetch all phone_no from funder_users_list
    useEffect(() => {
        const fetchFunderPhones = async () => {
            try {
                const colRef = collection(db, "udhyogini_features");
                const snap = await getDocs(colRef);
                const arr = snap.docs.map(docSnap => {
                    const d = docSnap.data();
                    // choose field name where you stored phone
                    return String(d.phone_no || d.phone || "").trim();
                }).filter(p => p); // filter nonempty
                setPhoneNumbers(arr);
                setLoaded(true);
            } catch (err) {
                console.error("Error fetching funder_users_list:", err);
                Swal.fire("Error", "Failed to load funder users", "error");
            }
        };

        fetchFunderPhones();
    }, []);

    const handleRun = async () => {
        if (!loaded) {
            Swal.fire("Info", "Still loading funder users...", "info");
            return;
        }
        if (phoneNumbers.length === 0) {
            Swal.fire("Error", "No phone numbers found in funder_users_list", "error");
            return;
        }

        setRunning(true);
        let success = 0;
        let failed = 0;

        const BATCH_LIMIT = 700;

        for (let i = 0; i < phoneNumbers.length; i += BATCH_LIMIT) {
            const chunk = phoneNumbers.slice(i, i + BATCH_LIMIT);
            const batch = writeBatch(db);

            for (let phone of chunk) {
                try {
                    phone = String(phone).trim();
                    if (!phone) {
                        failed++;
                        continue;
                    }

                    // Query app_referral where phone matches
                    const q = query(collection(db, "app_referral"), where("phone", "==", phone));
                    const snap = await getDocs(q);

                    if (snap.empty) {
                        console.warn("Not found in app_referral:", phone);
                        failed++;
                    } else {
                        snap.docs.forEach(docSnap => {
                            const ref = doc(db, "app_referral", docSnap.id);
                            batch.update(ref, { referral_code: "nascom" });
                        });
                        success++;
                    }
                } catch (err) {
                    console.error("Error with phone:", phone, err);
                    failed++;
                }
            }

            try {
                await batch.commit();
            } catch (err) {
                console.error("Batch commit error:", err);
                // If commit failed for chunk, count all as failed
                failed += chunk.length;
            }
        }

        setRunning(false);
        setResult({ success, failed });
        Swal.fire("Done", `Updated ${success} phones, failed ${failed}`, "success");
    };

    return (
        <div className="container p-4">
            <h3>🔁 Bulk Referral Code Updater</h3>
            {!loaded ? (
                <p>Loading funder users...</p>
            ) : (
                <>
                    <p>Total Funders: {phoneNumbers.length}</p>
                    <button
                        className="btn btn-primary"
                        onClick={handleRun}
                        disabled={running}
                    >
                        {running ? "Processing..." : "Start Update"}
                    </button>
                    {(result.success || result.failed) && (
                        <div className="mt-3">
                            <p>✅ Updated: {result.success}</p>
                            <p>❌ Failed: {result.failed}</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default BulkReferralUpdater;


// // // BulkReferralUpdater.jsx

// // import React, { useState } from "react";
// // import { collection, query, where, getDocs, doc, writeBatch } from "firebase/firestore";
// // import db from "./Firebase";
// // import Swal from "sweetalert2";

// // const BulkReferralUpdater = () => {
// //     // ✅ Predefined list of phone numbers
// //     const phoneNumbers = [

// //     ];

// //     const [running, setRunning] = useState(false);
// //     const [result, setResult] = useState({ success: 0, failed: 0 });

// //     const handleRun = async () => {
// //         if (phoneNumbers.length === 0) {
// //             Swal.fire("Error", "No phone numbers to process", "error");
// //             return;
// //         }

// //         setRunning(true);
// //         let success = 0;
// //         let failed = 0;

// //         const BATCH_LIMIT = 400;

// //         for (let i = 0; i < phoneNumbers.length; i += BATCH_LIMIT) {
// //             const chunk = phoneNumbers.slice(i, i + BATCH_LIMIT);
// //             const batch = writeBatch(db);

// //             for (let phone of chunk) {
// //                 try {
// //                     phone = String(phone).trim();
// //                     if (!phone) {
// //                         failed++;
// //                         continue;
// //                     }

// //                     const q = query(collection(db, "app_referral"), where("phone", "==", phone));
// //                     const snap = await getDocs(q);

// //                     if (snap.empty) {
// //                         console.warn("Not found:", phone);
// //                         failed++;
// //                     } else {
// //                         snap.docs.forEach(docSnap => {
// //                             const ref = doc(db, "app_referral", docSnap.id);
// //                             batch.update(ref, { referral_code: "nascom" });
// //                         });
// //                         success++;
// //                     }
// //                 } catch (err) {
// //                     console.error("Error with", phone, err);
// //                     failed++;
// //                 }
// //             }

// //             try {
// //                 await batch.commit();
// //             } catch (err) {
// //                 console.error("Batch error:", err);
// //                 failed += chunk.length;
// //             }
// //         }

// //         setRunning(false);
// //         setResult({ success, failed });
// //         Swal.fire("✅ Done", `Updated ${success} phones, failed ${failed}`, "success");
// //     };

// //     return (
// //         <div className="container p-4">
// //             <h3>🔁 Update Referral Code for Users</h3>
// //             <p>Total Numbers: {phoneNumbers.length}</p>

// //             <button className="btn btn-primary" onClick={handleRun} disabled={running}>
// //                 {running ? "Processing..." : "Start Update"}
// //             </button>

// //             {(result.success || result.failed) && (
// //                 <div className="mt-3">
// //                     <p>✅ Updated: {result.success}</p>
// //                     <p>❌ Failed: {result.failed}</p>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default BulkReferralUpdater;
